import { BACKGROUND_COLORS, PRIMARY_COLORS, SECONDARY_COLORS } from "@/constants/theme-colors"

export function isReduxiDomain(host?: string): boolean {
    if (!host) {
        return false
    }
    return host === "reduxi.app" || host.endsWith(".reduxi.app")
}

type ThemeColors = {
    default: string
    "dark-blue": string
    white: string
    yellow: string
    "red-gray": string
    "energy-blue": string
    "dark-orange": string
    "dark-green": string
    "green-gray": string
    "white-gray": string
    "yellow-blue": string
    "dark-yellow-blue": string
    "blue-green": string
    "energy-cyan": string
    "dark-cyan": string
    "white-blue": string
    "dark-light-blue": string
    "blue-orange": string
    "emerald-white": string
    "blue-gold": string
    "navy-gold": string
    "charcoal-blue": string
}

const primaryColors: ThemeColors = PRIMARY_COLORS as ThemeColors
const secondaryColors: ThemeColors = SECONDARY_COLORS as ThemeColors
const backgroundColors: ThemeColors = BACKGROUND_COLORS as ThemeColors

export function getThemePrimaryColor(theme: string, host?: string): string {
    if (isReduxiDomain(host)) {
        const customTheme = localStorage.getItem("customTheme")
        if (customTheme) {
            try {
                const parsed = JSON.parse(customTheme)
                if (parsed["--theme-shade"]) {
                    return parsed["--theme-shade"]
                }
            } catch (e) {
                // eslint-disable-line no-empty
            }
        }
    }

    if (!Object.prototype.hasOwnProperty.call(primaryColors, theme)) {
        theme = "default"
    }

    return primaryColors[theme as keyof ThemeColors]
}

export function getPWAThemePrimaryColor(theme: string, host?: string): string {
    if (isReduxiDomain(host)) {
        const customTheme = localStorage.getItem("customTheme")
        if (customTheme) {
            try {
                const parsed = JSON.parse(customTheme)
                if (parsed["--theme-shade"]) {
                    return parsed["--theme-shade"]
                }
            } catch (e) {
                // eslint-disable-line no-empty
            }
        }
    }

    if (!Object.prototype.hasOwnProperty.call(backgroundColors, theme)) {
        theme = "default"
    }

    return backgroundColors[theme as keyof ThemeColors]
}

export function getThemeSecondaryColor(theme: string, host?: string): string {
    if (isReduxiDomain(host)) {
        const customTheme = localStorage.getItem("customTheme")
        if (customTheme) {
            try {
                const parsed = JSON.parse(customTheme)
                if (parsed["--theme-primary"]) {
                    return parsed["--theme-primary"]
                }
            } catch (e) {
                // eslint-disable-line no-empty
            }
        }
    }

    if (!Object.prototype.hasOwnProperty.call(secondaryColors, theme)) {
        theme = "default"
    }

    return secondaryColors[theme as keyof ThemeColors]
}
